import React, { useState } from 'react';
import { api } from '../api';
import { useAuth } from '../App';

export default function Profile() {
  const { user, checkAuth } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [nameSuccess, setNameSuccess] = useState('');
  const [nameError, setNameError] = useState('');
  const [pwSuccess, setPwSuccess] = useState('');
  const [pwError, setPwError] = useState('');
  const [savingName, setSavingName] = useState(false);
  const [savingPw, setSavingPw] = useState(false);

  const handleNameSubmit = async (e) => {
    e.preventDefault();
    setNameError('');
    setNameSuccess('');
    if (!name.trim()) { setNameError('Name cannot be empty.'); return; }
    if (name.trim() === user?.name) { setNameSuccess('No changes to save.'); return; }
    setSavingName(true);
    try {
      await api.updateProfile({ name: name.trim() });
      await checkAuth();
      setNameSuccess('Display name updated.');
    } catch (err) {
      setNameError(err.message);
    } finally {
      setSavingName(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPwError('');
    setPwSuccess('');
    if (!currentPassword) { setPwError('Enter your current password.'); return; }
    if (!newPassword) { setPwError('Enter a new password.'); return; }
    if (newPassword.length < 8) { setPwError('New password must be at least 8 characters.'); return; }
    if (newPassword !== confirmPassword) { setPwError('New passwords do not match.'); return; }
    setSavingPw(true);
    try {
      await api.updateProfile({ current_password: currentPassword, new_password: newPassword });
      setPwSuccess('Password updated.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPwError(err.message);
    } finally {
      setSavingPw(false);
    }
  };

  return (
    <div className="page container">
      <div className="form-page">
        <div className="form-page-header">
          <h1 className="page-title">Profile</h1>
          <p>Update your display name or change your password.</p>
        </div>

        <form className="admin-section glass" onSubmit={handleNameSubmit}>
          <h3>Display Name</h3>
          <p className="form-hint" style={{ marginBottom: 'var(--space-md)' }}>This is how your name appears on updates and assignments.</p>
          {nameError && <div className="alert alert-error">{nameError}</div>}
          {nameSuccess && <div className="alert alert-success">{nameSuccess}</div>}
          <div className="form-group">
            <label className="form-label" htmlFor="profile-name">Name</label>
            <input id="profile-name" className="form-input" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <button type="submit" className="btn btn-primary btn-sm" disabled={savingName}>
            {savingName ? 'Saving…' : 'Save Name'}
          </button>
        </form>

        <form className="admin-section glass" onSubmit={handlePasswordSubmit}>
          <h3>Change Password</h3>
          {pwError && <div className="alert alert-error">{pwError}</div>}
          {pwSuccess && <div className="alert alert-success">{pwSuccess}</div>}
          <div className="form-group">
            <label className="form-label" htmlFor="current-pw">Current Password</label>
            <input id="current-pw" type="password" className="form-input" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} autoComplete="current-password" />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="new-pw">New Password</label>
            <input id="new-pw" type="password" className="form-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="confirm-pw">Confirm New Password</label>
            <input id="confirm-pw" type="password" className="form-input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete="new-password" />
          </div>
          <button type="submit" className="btn btn-primary btn-sm" disabled={savingPw}>
            {savingPw ? 'Updating…' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
